
declare var window: any;
declare let XtremePush: any;
declare let cordova: any;


import { Injectable } from '@angular/core';
import { AffiliateTrackerInterface, AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import {  Platform } from '@ionic/angular';
import { UserSessionService } from '../user-session/user-session.service';
import { ConfigService } from '../config/config.service';


@Injectable({
  providedIn: "root",
})
export class XtremepushService implements AffiliateTrackerInterface {
  protected configVars: any;
  protected params: any;
  private isTrackerSetup: boolean = false;
  private customer;
  private trackerData = null;
  private brand: String = "";
  private jurisdiction: String = "";
  private canXTPPageViewTrigger: boolean = false;

  constructor(
    private config: ConfigService,
    private userSession: UserSessionService,
    private platform: Platform
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });
  }

  initialize(): Promise<AffiliateTrackerInterface> {
    setTimeout(() => {
      this.setup();
    }, 8000);

    return Promise.resolve(this);
  }

  getTrackerName() {
    return "XTP";
  }
  login(cbParams: AffiliateTrackerCallbackParams) {
    console.log("XTP login");
    if (this.isTrackerSetup) {
      if (this.platform.is("capacitor")) {
        console.log("XTP setID");
        XtremePush.setExternalId(this.formatId(cbParams.customer_id));
      } else {
        window.xtremepush(
          "set",
          "user_id",
          this.formatId(cbParams.customer_id)
        );
      }
    }
  }

  setup() {
    let webTrackerUrl = this.config.getXtremeWebSdkUrl();
    let isMobileApp = this.platform.is("capacitor");

    if (webTrackerUrl && webTrackerUrl !== "" && !isMobileApp) {
      const script = document.createElement("script");

      script.innerHTML = `(function(p,u,s,h,e,r,l,i,b) {p['XtremePushObject']=s;p[s]=function(){
                (p[s].q=p[s].q||[]).push(arguments)};i=u.createElement('script');i.async=1;
                i.src=h;b=u.getElementsByTagName('script')[0];b.parentNode.insertBefore(i,b);
              })(window,document,'xtremepush', '${webTrackerUrl}');`;

      document.head.appendChild(script);

      this.isTrackerSetup = true;

      this.brand = "";
      this.jurisdiction = "";

      window.xtremepush("ready", function () {
        // Checking current user permission
        var permission = window.xtremepush("push", "permission");
        
        if (permission == "default" && Notification.permission != "granted") {
          // User has not allowed or blocked notifications yet. Creating subscribe button
            window.xtremepush("push", "prompt", {
              allowCallback: function () {
                // User clicked allow. Removing subscribe button
                
              },
              denyCallback: function () {
                // User clicked deny. Removing subscribe button
                
              },
              dismissCallback: function () {
                // User dismissed dialog. It is possible to prompt again later
              },
            });
         
        } else {
          switch (permission) {
            case "granted":
              // User has already allowed notifications permissions
              break;
            case "denied":
              // User has already blocked notifications permissions
              break;
            case "unavailable":
              // Push messaging is not available in user browser
              break;
          }
        }
      });


    } else {
      this.isTrackerSetup = false;
    }

    if (this.platform.is("capacitor")) {
      this.platform.ready().then((readySource) => {
        this.isTrackerSetup = true;
        this.registerMobileXtremePush();
      });
    }
  }

  registerMobileXtremePush() {
    let iosAppKey = this.config.getXtremeIosAppKey();
    let androidAppKey = this.config.getXtremeAndroidAppKey(); //zsz5uDONgh734AF8otcCtCzE8pqnmjBh
    let gcmProjectNumber = this.config.getXtremeGcmProjectNumber();
    let appKey = this.platform.is("ios") ? iosAppKey : androidAppKey;
    
    XtremePush.register({
      appKey: appKey,
      debugLogsEnabled: false,
      inappMessagingEnabled: true,
      inboxEnabled: true,
      serverUrl: "https://sdk.us.xtremepush.com",
      ios: {
        pushPermissionsRequest: true,
        //if using locations
        locationsEnabled: false,
        beaconsEnabled: false,
        locationsPermissionsRequest: false,
      },
      android: {
        gcmProjectNumber: gcmProjectNumber,
        pushPermissionsRequest: true,
        //if using locations
        geoEnabled: false,
        beaconsEnabled: false,
      },
    });
  }

  private track(data?: any) {
    if (!this.isTrackerSetup) {
      console.log("tracker config not set.");
      return;
    }

    if (
      !!this.trackerData &&
      data.type == "pageView" &&
      this.trackerData.detail.navigationState == data.detail.navigationState
    ) {
      //skip if pageView url is the same;
    } else {
      if (!this.platform.is("capacitor")) {
        window.xtremepush("event", data.type, data);
      } else {
        XtremePush.hitEvent(data.type, data);
      }
    }
  }

  private getDeviceOS() {
    let OSName = "";
    let navigator = window.navigator;
    if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
    if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";
    if (navigator.appVersion.indexOf("Android ") != -1) OSName = "Android ";
    if (navigator.appVersion.indexOf("iPhone ") != -1) OSName = "IOS ";
    return OSName;
  }

  getDeviceType() {
    let deviceType = "dekstop";
    if (this.platform.is("mobileweb") && !this.platform.is("capacitor")) {
      deviceType = "mobileWeb";
    } else if (this.platform.is("capacitor")) {
      deviceType = "mobileApp";
    }

    if (this.platform.is("tablet")) deviceType = "tablet";

    console.log("Device type:", deviceType);
    return deviceType;
  }

  formatId = (customerId) => {
    let prefix = "";
    let config = this.config.getXtpPlayerPrefix();
    if (!!config) {
      prefix = config;
    }

    return prefix + customerId;
  };

  logout() {}

  signupStep1Complete(cbParams: AffiliateTrackerCallbackParams) {}

  loginError(cbParams: AffiliateTrackerCallbackParams) {}

  forgotPassword(cbParams: AffiliateTrackerCallbackParams) {}

  closeAccount(cbParams: AffiliateTrackerCallbackParams) {}

  sendPageHistoryEvent(pageName) {
    let pagePath = pageName.page ? pageName.page : pageName
    let websiteUrl = document.location.origin;
    let virtualRoute = `${websiteUrl}/${pagePath} `;
    let data = {
      type: "pageView",
      url: virtualRoute,
    };

    //Send event based on config from client side. As of now, client is sending only pageView event for XTP.
    this.canXTPPageViewTrigger = this.config.getConfig().FEATURE_XTP_DISABLE_PAGEVIEW_EVENT ? (this.config.getConfig().FEATURE_XTP_DISABLE_PAGEVIEW_EVENT !== '1' ? true : false) : false;
    if (this.canXTPPageViewTrigger) {
      this.track(data);
    }
    
  }

  signupComplete(cbParams: AffiliateTrackerCallbackParams) {}

  deposit(cbParams: AffiliateTrackerCallbackParams) {}

  withdraw(cbParams: AffiliateTrackerCallbackParams) {}

  gameLaunched(cbParams: AffiliateTrackerCallbackParams) {}

  depositFailed(cbParams: AffiliateTrackerCallbackParams) {}

  liveDealerLaunch() {}

  liveDealerClosed() {}

  gameClosed() {}

  addToBetslip(eventData) {}

  betPlaced(eventData) {}

  conversion(eventData) {}
}

